module.exports = __webpack_public_path__ + "static/Process Evaluation-86d43700adf6785397bddc1aacc9e46a.webp";